export default "__VITE_ASSET__1ef4a05a__"